// Dicionário PT/EN/ES da presale pública (Presale-1, 2026-06-05)
// Regras: PT = texto atual byte a byte (zero regressão); EN/ES tom de turismo natural.
// Conteúdo dinâmico do banco (nomes de tours, descrições, chat) NÃO é traduzido.
export const PRESALE_LANGS = ['pt', 'en', 'es'];

export const presaleDict = {
  pt: {
    // ── Calendário / DateRequestSection ──
    months: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
    weekdays: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'],
    preferred_date: 'Data preferida:',
    choose_date_for_tour: 'Escolha uma data para este passeio',
    close_cal: 'Fechar ▲',
    open_cal: 'Abrir ▼',
    checking_availability: 'Verificando disponibilidade...',
    available: 'Disponível',
    sold_out: 'Esgotado',
    current_date: 'Data atual',
    calendar_note: '💬 Selecione um dia disponível para alterar sua preferência. A vaga só é confirmada quando a venda for finalizada.',
    saving: 'Salvando...',
    confirm_date: 'Confirmar data:',

    // ── TourItemCard ──
    item: 'Item',
    to_confirm_consultant: 'A confirmar com o consultor',
    know_more: '📍 Saiba mais →',
    service_details_pending: 'Os detalhes deste serviço serão informados pelo seu consultor. 💬',
    consultant_tip: '🏔️ DICA DO CONSULTOR',
    dayuse_line1: 'Ideal para quem quer passar o dia no parque Farellones.',
    dayuse_line2_pre: 'Solicite o ',
    dayuse_line2_strong: 'Day Use',
    dayuse_line2_post: ' com o consultor.',
    includes: '✓ INCLUI',
    not_includes: '✗ NÃO INCLUI',
    date: '📅 Data',
    to_schedule: 'A agendar',
    passengers: '👥 Passageiros',
    adult: 'adulto',
    adults: 'adultos',
    kid: 'criança',
    kids: 'crianças',
    subtotal: 'Subtotal',
    values: 'Valores',
    payment_discount: 'Desconto por pagamento',
    pix_disc_suffix: '% desc.',

    // ── Black Friday (nov/2026) ──
    bf_badge: 'BLACK FRIDAY',
    bf_headline: 'Mês de Black Friday na Full Tour!',
    bf_pix_label: 'de desconto no Pix',
    bf_card_label: 'de desconto no cartão',
    bf_valid: 'Válido para passeios de Santiago e Atacama, com pagamento até',
    bf_note: 'Fale com seu consultor sobre o parcelamento no Pix e no cartão.',
    card_label_short: '💳 Cartão',

    // ── Status / badges ──
    badge_canceled: '✗ Orçamento cancelado',
    badge_approved: '✓ Orçamento aprovado por você',
    badge_refused: '✗ Orçamento recusado',
    badge_waiting: '⏳ Aguardando sua resposta',
    badge_expired: '⏰ Orçamento expirado',
    refuse_reason_label: 'Motivo da recusa:',

    // ── Hero ──
    hello: 'Olá,',
    hero_text: 'Preparamos este orçamento exclusivamente para você. Confira os passeios e, quando estiver pronto, é só aprovar!',
    reference: 'Referência',
    valid_until: 'Válido até',

    // ── Loading / erro ──
    loading_budget: 'Carregando seu orçamento...',
    load_error: 'Não foi possível carregar o orçamento. Verifique o link ou tente novamente.',

    // ── Lista de serviços ──
    service: 'serviço',
    services: 'serviços',
    in_the_budget: 'no orçamento',

    // ── Chat / CommentsSection ──
    chat_title: 'Conversa com o consultor',
    no_messages: 'Nenhuma mensagem ainda. Envie sua dúvida ou sugestão!',
    whats_your_name: 'Qual é o seu nome?',
    your_name: 'Seu nome',
    confirm_and_send: 'Confirmar e enviar',
    write_message: 'Escreva sua mensagem...',
    send_error: 'Erro ao enviar. Tente novamente.',

    // ── Modal de pagamento — header / steps ──
    step_id: '🪪 Identificação',
    step_method: '💳 Forma de pagamento',
    step_dates: '📅 Verificação de datas',
    step_pix: '📱 Pagamento via PIX',
    step_card: '💳 Dados do cartão',
    step_success: '✅ Pagamento confirmado!',
    loading_payment_options: 'Carregando opções de pagamento...',

    // ── CPF ──
    cpf_intro: 'Para processar o pagamento precisamos do seu CPF. A reserva e o CPF informado precisam ser do titular do cartão utilizado no pagamento.',
    cpf_label: 'CPF do titular do cartão',
    cpf_invalid: 'Informe um CPF válido (11 dígitos).',
    cpf_save_error: 'Erro ao salvar CPF.',
    continue_arrow: 'Continuar →',

    // ── Erros pagamento ──
    availability_error: 'Erro ao verificar disponibilidade.',
    payment_settings_error: 'Erro ao carregar configurações de pagamento.',
    pix_error: 'Erro ao gerar PIX.',
    card_fill_all: 'Preencha todos os dados do cartão (validade no formato MM/AA).',
    cep_required: 'Informe o CEP (ou código postal) de cobrança.',
    cep_searching: 'Buscando endereço…',
    cep_manual_hint: 'Não encontramos o endereço deste CEP. Preencha manualmente.',
    street_required: 'Informe a rua / endereço de cobrança.',
    street_placeholder: 'Rua / endereço',
    district_placeholder: 'Bairro / cidade',
    address_number_required: 'Informe o número do endereço de cobrança.',
    invalid_month: 'Mês de validade inválido.',
    card_expired: 'Cartão expirado. Verifique a validade (MM/AA).',
    payment_not_confirmed: 'Pagamento não confirmado. Verifique os dados.',
    payment_error: 'Erro ao processar pagamento.',

    // ── Modal step method ──
    instant_payment: 'Pagamento instantâneo',
    pix_economy: '🐷 Economia de',
    card_economy: '💳 Economia de',
    of: 'de',
    per: 'por',
    no_interest: 'sem juros',
    with_interest: 'com juros',
    or: 'ou',
    x_of: 'x de',
    how_pay_pix: 'Como prefere pagar com PIX?',
    most_chosen: 'Mais escolhido',
    secure_spot_with: 'Garanta sua vaga agora com apenas',
    down_50: 'Entrada de 50%',
    full_payment: 'Pagamento integral',
    balance_48h: 'Saldo em até 48h antes da viagem',
    balance_48h_short: 'Saldo até 48h antes da viagem',
    confirmed_immediately: 'Reserva confirmada imediatamente',
    nothing_more: 'nada mais a pagar',
    plus_later: 'depois',
    today_confirmed: 'hoje — reserva confirmada na hora',
    remaining: 'Restante',
    paid_48h_before: 'pago até 48h antes',
    of_boarding: 'de embarcar',
    in_pix: 'no PIX',
    in_card: 'no cartão',
    you_save: '🐷 Você economiza',
    card_you_save: '💳 Você economiza',
    transfer_note: ' (desconto nos passeios — transfer já a preço de custo, exclusivo para clientes)',
    manager_discount_incl: '🎁 inclui desconto gerencial de',
    manager_discount_applied_pre: '🎁 Desconto gerencial:',
    manager_discount_applied_post: 'já aplicado',
    on_tours_only: 'sobre os passeios',
    trust_line: 'Sua reserva com uma empresa com 10 anos no mercado e 4 prêmios Travelers Choice',
    checking_dates: 'Verificando datas...',
    generate_pix: '🟩 Gerar PIX ·',
    pay_with_card: '💳 Pagar com cartão',
    processing: 'Processando...',

    // ── Modal step dates ──
    dates_intro: 'Antes de confirmar o pagamento, verifique se todas as datas dos seus passeios têm vagas disponíveis:',
    no_date_selected: 'Sem data selecionada',
    person: 'pessoa',
    people: 'pessoas',
    avail_ok: '✓ Disponível',
    choose_a_date: 'Escolha uma data',
    no_spots: 'Sem vagas',
    available_count: 'disponíveis',
    unavailable: 'Indisponível',
    dates_warning: '⚠️ Alguns passeios precisam de ajuste de data. Use o calendário em cada passeio (acima) para selecionar uma data disponível e volte aqui.',
    back: '← Voltar',
    confirm_and_pay: 'Confirmar e pagar →',
    close_adjust_dates: '← Fechar e ajustar datas',

    // ── Modal step pix ──
    generating_qr: 'Gerando QR Code PIX...',
    or_copy_code: 'Ou copie o código PIX:',
    copy_code: '📋 Copiar código',
    code_copied: 'Código copiado!',
    paying_now: '📲 Pagando agora',
    remaining_hour: '⏳ Restante',
    balance_note: 'O saldo restante deve ser pago até 48h antes do primeiro serviço.',
    waiting_confirmation: 'Aguardando confirmação do pagamento...',
    auto_check_5s: 'Verificando automaticamente a cada 5 segundos',

    // ── Modal step card ──
    installments_title: 'Parcelamento',
    cash: 'à vista',
    total_word: 'total',
    card_data: 'Dados do cartão',
    name_on_card: 'Nome no cartão',
    card_number: 'Número do cartão',
    billing_address: '📍 Endereço de cobrança',
    required: '(obrigatório)',
    cep_placeholder: 'CEP',
    number_placeholder: 'Número',

    // ── Modal step success ──
    payment_confirmed: 'Pagamento confirmado!',
    success_text: 'Sua reserva foi criada com sucesso. Em breve você receberá a confirmação e o voucher com todos os detalhes.',
    see_my_reservation: 'Ver minha reserva',

    // ── Coluna direita ──
    immediate_confirmation: '· confirmação imediata',
    credit_card_title: 'Cartão de crédito',
    budget_summary: 'Resumo do orçamento',
    pix_down: '✅ PIX entrada',
    pix_paid: '✅ PIX — pago',
    card_paid_prefix: '✅ Cartão',
    pay_balance_48h: 'Pague o saldo até 48h antes de embarcar',
    total_to_pay: 'Total a pagar',
    valid_until_pre: '⏱️ Valores válidos até',
    valid_until_post: '· Reserve agora e garanta esses valores!',

    // ── Ações ──
    your_answer: 'Sua resposta',
    refuse: 'Recusar',
    refuse_intro: 'Nos conte o motivo (opcional). Sua opinião nos ajuda a melhorar!',
    refuse_placeholder: 'Ex: preço fora do orçamento, datas indisponíveis...',
    confirm_refuse: 'Confirmar recusa',
    back_simple: 'Voltar',
    approve_error: 'Erro ao aprovar. Tente novamente.',
    refuse_error: 'Erro ao recusar. Tente novamente.',
    approved_title: 'Orçamento aprovado!',
    approved_text: 'Nossa equipe entrará em contato em breve para finalizar sua reserva.',

    // ── Rodapé ──
    footer_about: 'Somos especialistas em turismo de experiência em Santiago, Buenos Aires e destinos da América do Sul. Cada viagem é planejada com cuidado e atenção para que você viva momentos inesquecíveis.',
    download_app: 'Baixe o FT App',
    available_on_ios: 'Disponível na',
    available_on_android: 'Disponível no',
    footer_personal: 'Este orçamento é pessoal e intransferível · Ref.',
    terms_title: 'Termos e condições do orçamento',

    // ── Aviso pagamento internacional (vazio em PT — não renderizar) ──
    intl_payment_note: '',
    rate_error: 'Cotação indisponível — tente novamente',
  },

  en: {
    months: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    weekdays: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
    preferred_date: 'Preferred date:',
    choose_date_for_tour: 'Choose a date for this tour',
    close_cal: 'Close ▲',
    open_cal: 'Open ▼',
    checking_availability: 'Checking availability...',
    available: 'Available',
    sold_out: 'Sold out',
    current_date: 'Current date',
    calendar_note: '💬 Select an available day to change your preference. Your spot is only confirmed once the booking is finalized.',
    saving: 'Saving...',
    confirm_date: 'Confirm date:',

    item: 'Item',
    to_confirm_consultant: 'To be confirmed with your consultant',
    know_more: '📍 Learn more →',
    service_details_pending: 'The details of this service will be provided by your consultant. 💬',
    consultant_tip: "🏔️ CONSULTANT'S TIP",
    dayuse_line1: 'Perfect for spending the whole day at Farellones park.',
    dayuse_line2_pre: 'Ask your consultant for the ',
    dayuse_line2_strong: 'Day Use',
    dayuse_line2_post: ' option.',
    includes: '✓ INCLUDED',
    not_includes: '✗ NOT INCLUDED',
    date: '📅 Date',
    to_schedule: 'To be scheduled',
    passengers: '👥 Passengers',
    adult: 'adult',
    adults: 'adults',
    kid: 'child',
    kids: 'children',
    subtotal: 'Subtotal',
    values: 'Pricing',
    payment_discount: 'Payment method discount',
    pix_disc_suffix: '% off',

    // ── Black Friday (nov/2026) ──
    bf_badge: 'BLACK FRIDAY',
    bf_headline: 'Black Friday month at Full Tour!',
    bf_pix_label: 'off when you pay with Pix',
    bf_card_label: 'off when you pay by card',
    bf_valid: 'Valid for Santiago and Atacama tours, paid by',
    bf_note: 'Talk to your consultant about Pix and card installments.',
    card_label_short: '💳 Card',

    badge_canceled: '✗ Quote canceled',
    badge_approved: '✓ Quote approved by you',
    badge_refused: '✗ Quote declined',
    badge_waiting: '⏳ Awaiting your reply',
    badge_expired: '⏰ Quote expired',
    refuse_reason_label: 'Reason for declining:',

    hello: 'Hello,',
    hero_text: "We've prepared this quote exclusively for you. Take a look at the tours and, when you're ready, just approve it!",
    reference: 'Reference',
    valid_until: 'Valid until',

    loading_budget: 'Loading your quote...',
    load_error: 'We could not load your quote. Please check the link or try again.',

    service: 'service',
    services: 'services',
    in_the_budget: 'in this quote',

    chat_title: 'Chat with your consultant',
    no_messages: 'No messages yet. Send us your questions or suggestions!',
    whats_your_name: 'What is your name?',
    your_name: 'Your name',
    confirm_and_send: 'Confirm and send',
    write_message: 'Write your message...',
    send_error: 'Error sending message. Please try again.',

    step_id: '🪪 Identification',
    step_method: '💳 Payment method',
    step_dates: '📅 Date check',
    step_pix: '📱 PIX payment',
    step_card: '💳 Card details',
    step_success: '✅ Payment confirmed!',
    loading_payment_options: 'Loading payment options...',

    cpf_intro: 'To process the payment we need your CPF (Brazilian tax ID). The booking and the CPF entered must belong to the holder of the card used for payment.',
    cpf_label: 'Cardholder CPF',
    cpf_invalid: 'Please enter a valid CPF (11 digits).',
    cpf_save_error: 'Error saving CPF.',
    continue_arrow: 'Continue →',

    availability_error: 'Error checking availability.',
    payment_settings_error: 'Error loading payment settings.',
    pix_error: 'Error generating PIX.',
    card_fill_all: 'Please fill in all card details (expiry in MM/YY format).',
    cep_required: 'Please enter the billing postal code.',
    cep_searching: 'Looking up address…',
    cep_manual_hint: "We couldn't find the address for this postal code. Please fill it in manually.",
    street_required: 'Please enter the billing street / address.',
    street_placeholder: 'Street / address',
    district_placeholder: 'District / city',
    address_number_required: 'Please enter the billing address number.',
    invalid_month: 'Invalid expiry month.',
    card_expired: 'Card expired. Please check the expiry date (MM/YY).',
    payment_not_confirmed: 'Payment not confirmed. Please check your details.',
    payment_error: 'Error processing payment.',

    instant_payment: 'Instant payment',
    pix_economy: '🐷 You save',
    card_economy: '💳 You save',
    of: 'from',
    per: 'now',
    no_interest: 'interest-free',
    with_interest: 'with interest',
    or: 'or',
    x_of: 'x of',
    how_pay_pix: 'How would you like to pay with PIX?',
    most_chosen: 'Most popular',
    secure_spot_with: 'Secure your spot now with only',
    down_50: '50% deposit',
    full_payment: 'Full payment',
    balance_48h: 'Balance due up to 48h before your trip',
    balance_48h_short: 'Balance due 48h before the trip',
    confirmed_immediately: 'Booking confirmed immediately',
    nothing_more: 'nothing more to pay',
    plus_later: 'later',
    today_confirmed: 'today — booking confirmed instantly',
    remaining: 'Balance',
    paid_48h_before: 'due up to 48h before',
    of_boarding: 'departure',
    in_pix: 'with PIX',
    in_card: 'with card',
    you_save: '🐷 You save',
    card_you_save: '💳 You save',
    transfer_note: ' (discount on tours — transfers already at cost price, exclusive for our clients)',
    manager_discount_incl: '🎁 includes a special manager discount of',
    manager_discount_applied_pre: '🎁 Manager discount:',
    manager_discount_applied_post: 'already applied',
    on_tours_only: 'on tours only',
    trust_line: 'Book with a company with 10 years in the market and 4 Travelers Choice awards',
    checking_dates: 'Checking dates...',
    generate_pix: '🟩 Generate PIX ·',
    pay_with_card: '💳 Pay with card',
    processing: 'Processing...',

    dates_intro: 'Before confirming your payment, please check that all your tour dates have spots available:',
    no_date_selected: 'No date selected',
    person: 'person',
    people: 'people',
    avail_ok: '✓ Available',
    choose_a_date: 'Choose a date',
    no_spots: 'No spots left',
    available_count: 'available',
    unavailable: 'Unavailable',
    dates_warning: '⚠️ Some tours need a date adjustment. Use the calendar on each tour (above) to pick an available date and come back here.',
    back: '← Back',
    confirm_and_pay: 'Confirm and pay →',
    close_adjust_dates: '← Close and adjust dates',

    generating_qr: 'Generating PIX QR Code...',
    or_copy_code: 'Or copy the PIX code:',
    copy_code: '📋 Copy code',
    code_copied: 'Code copied!',
    paying_now: '📲 Paying now',
    remaining_hour: '⏳ Balance',
    balance_note: 'The remaining balance must be paid up to 48h before your first service.',
    waiting_confirmation: 'Waiting for payment confirmation...',
    auto_check_5s: 'Checking automatically every 5 seconds',

    installments_title: 'Installments',
    cash: 'one payment',
    total_word: 'total',
    card_data: 'Card details',
    name_on_card: 'Name on card',
    card_number: 'Card number',
    billing_address: '📍 Billing address',
    required: '(required)',
    cep_placeholder: 'Postal code',
    number_placeholder: 'Number',

    payment_confirmed: 'Payment confirmed!',
    success_text: 'Your booking was created successfully. You will soon receive the confirmation and your voucher with all the details.',
    see_my_reservation: 'View my booking',

    immediate_confirmation: '· instant confirmation',
    credit_card_title: 'Credit card',
    budget_summary: 'Quote summary',
    pix_down: '✅ PIX deposit',
    pix_paid: '✅ PIX — paid',
    card_paid_prefix: '✅ Card',
    pay_balance_48h: 'Pay the balance up to 48h before departure',
    total_to_pay: 'Total due',
    valid_until_pre: '⏱️ Prices valid until',
    valid_until_post: '· Book now and lock in these prices!',

    your_answer: 'Your reply',
    refuse: 'Decline',
    refuse_intro: 'Tell us why (optional). Your feedback helps us improve!',
    refuse_placeholder: 'E.g.: price out of budget, dates unavailable...',
    confirm_refuse: 'Confirm decline',
    back_simple: 'Back',
    approve_error: 'Error approving. Please try again.',
    refuse_error: 'Error declining. Please try again.',
    approved_title: 'Quote approved!',
    approved_text: 'Our team will contact you shortly to finalize your booking.',

    footer_about: 'We are experts in experiential tourism in Santiago, Buenos Aires and destinations across South America. Every trip is planned with care and attention so you can live unforgettable moments.',
    download_app: 'Download the FT App',
    available_on_ios: 'Available on the',
    available_on_android: 'Available on',
    footer_personal: 'This quote is personal and non-transferable · Ref.',
    terms_title: 'Quote terms and conditions',

    intl_payment_note: 'Prices are in Brazilian Reais (BRL). You can also pay in USD using the currency selector below.',

    // ── International payment (Nautt/Aloha) ──────────────────────────────────
    pay_currency_label: 'Pay in your currency',
    pay_currency_brl: 'BRL',
    step_ext_pay: '💳 International Payment',
    ext_pay_opening: 'Preparing your payment link...',
    ext_pay_opened: 'Your payment page is open in a new tab. Complete the payment there — this page updates automatically.',
    ext_pay_reopen: '🔗 Reopen payment page',
    ext_pay_waiting: 'Checking for payment confirmation...',
    ext_pay_error: 'Could not generate payment link. Please try again or contact your consultant.',
    rate_error: 'Rate unavailable — try again',
    coming_soon_short: 'soon',
    confirm_and_pay_usd: 'Continue to payment in',
  },

  es: {
    months: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
    weekdays: ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
    preferred_date: 'Fecha preferida:',
    choose_date_for_tour: 'Elige una fecha para este paseo',
    close_cal: 'Cerrar ▲',
    open_cal: 'Abrir ▼',
    checking_availability: 'Verificando disponibilidad...',
    available: 'Disponible',
    sold_out: 'Agotado',
    current_date: 'Fecha actual',
    calendar_note: '💬 Selecciona un día disponible para cambiar tu preferencia. El cupo solo se confirma cuando se finaliza la venta.',
    saving: 'Guardando...',
    confirm_date: 'Confirmar fecha:',

    item: 'Ítem',
    to_confirm_consultant: 'A confirmar con tu consultor',
    know_more: '📍 Más información →',
    service_details_pending: 'Los detalles de este servicio te los informará tu consultor. 💬',
    consultant_tip: '🏔️ CONSEJO DEL CONSULTOR',
    dayuse_line1: 'Ideal para quienes quieren pasar el día en el parque Farellones.',
    dayuse_line2_pre: 'Solicita el ',
    dayuse_line2_strong: 'Day Use',
    dayuse_line2_post: ' con tu consultor.',
    includes: '✓ INCLUYE',
    not_includes: '✗ NO INCLUYE',
    date: '📅 Fecha',
    to_schedule: 'Por agendar',
    passengers: '👥 Pasajeros',
    adult: 'adulto',
    adults: 'adultos',
    kid: 'niño',
    kids: 'niños',
    subtotal: 'Subtotal',
    values: 'Valores',
    payment_discount: 'Descuento por forma de pago',
    pix_disc_suffix: '% desc.',

    // ── Black Friday (nov/2026) ──
    bf_badge: 'BLACK FRIDAY',
    bf_headline: '¡Mes de Black Friday en Full Tour!',
    bf_pix_label: 'de descuento con Pix',
    bf_card_label: 'de descuento con tarjeta',
    bf_valid: 'Válido para paseos de Santiago y Atacama, con pago hasta el',
    bf_note: 'Habla con tu consultor sobre las cuotas con Pix y tarjeta.',
    card_label_short: '💳 Tarjeta',

    badge_canceled: '✗ Presupuesto cancelado',
    badge_approved: '✓ Presupuesto aprobado por ti',
    badge_refused: '✗ Presupuesto rechazado',
    badge_waiting: '⏳ Esperando tu respuesta',
    badge_expired: '⏰ Presupuesto vencido',
    refuse_reason_label: 'Motivo del rechazo:',

    hello: 'Hola,',
    hero_text: 'Preparamos este presupuesto exclusivamente para ti. Revisa los paseos y, cuando estés listo, ¡solo apruébalo!',
    reference: 'Referencia',
    valid_until: 'Válido hasta',

    loading_budget: 'Cargando tu presupuesto...',
    load_error: 'No pudimos cargar el presupuesto. Verifica el link o intenta nuevamente.',

    service: 'servicio',
    services: 'servicios',
    in_the_budget: 'en el presupuesto',

    chat_title: 'Conversación con el consultor',
    no_messages: 'Aún no hay mensajes. ¡Envía tu duda o sugerencia!',
    whats_your_name: '¿Cuál es tu nombre?',
    your_name: 'Tu nombre',
    confirm_and_send: 'Confirmar y enviar',
    write_message: 'Escribe tu mensaje...',
    send_error: 'Error al enviar. Intenta nuevamente.',

    step_id: '🪪 Identificación',
    step_method: '💳 Forma de pago',
    step_dates: '📅 Verificación de fechas',
    step_pix: '📱 Pago vía PIX',
    step_card: '💳 Datos de la tarjeta',
    step_success: '✅ ¡Pago confirmado!',
    loading_payment_options: 'Cargando opciones de pago...',

    cpf_intro: 'Para procesar el pago necesitamos tu CPF (identificación fiscal brasileña). La reserva y el CPF ingresado deben ser del titular de la tarjeta utilizada en el pago.',
    cpf_label: 'CPF del titular de la tarjeta',
    cpf_invalid: 'Ingresa un CPF válido (11 dígitos).',
    cpf_save_error: 'Error al guardar el CPF.',
    continue_arrow: 'Continuar →',

    availability_error: 'Error al verificar disponibilidad.',
    payment_settings_error: 'Error al cargar las opciones de pago.',
    pix_error: 'Error al generar el PIX.',
    card_fill_all: 'Completa todos los datos de la tarjeta (vencimiento en formato MM/AA).',
    cep_required: 'Ingresa el código postal de facturación.',
    cep_searching: 'Buscando dirección…',
    cep_manual_hint: 'No encontramos la dirección de este código postal. Complétala manualmente.',
    street_required: 'Ingresa la calle / dirección de facturación.',
    street_placeholder: 'Calle / dirección',
    district_placeholder: 'Barrio / ciudad',
    address_number_required: 'Ingresa el número de la dirección de facturación.',
    invalid_month: 'Mes de vencimiento inválido.',
    card_expired: 'Tarjeta vencida. Verifica la fecha de vencimiento (MM/AA).',
    payment_not_confirmed: 'Pago no confirmado. Verifica los datos.',
    payment_error: 'Error al procesar el pago.',

    instant_payment: 'Pago instantáneo',
    pix_economy: '🐷 Ahorro de',
    card_economy: '💳 Ahorro de',
    of: 'de',
    per: 'por',
    no_interest: 'sin intereses',
    with_interest: 'con intereses',
    or: 'o',
    x_of: 'x de',
    how_pay_pix: '¿Cómo prefieres pagar con PIX?',
    most_chosen: 'El más elegido',
    secure_spot_with: 'Asegura tu cupo ahora con solo',
    down_50: 'Anticipo del 50%',
    full_payment: 'Pago total',
    balance_48h: 'Saldo hasta 48h antes del viaje',
    balance_48h_short: 'Saldo hasta 48h antes del viaje',
    confirmed_immediately: 'Reserva confirmada de inmediato',
    nothing_more: 'nada más por pagar',
    plus_later: 'después',
    today_confirmed: 'hoy — reserva confirmada al instante',
    remaining: 'Saldo',
    paid_48h_before: 'pagado hasta 48h antes',
    of_boarding: 'de embarcar',
    in_pix: 'con PIX',
    in_card: 'con tarjeta',
    you_save: '🐷 Ahorras',
    card_you_save: '💳 Ahorras',
    transfer_note: ' (descuento en los paseos — el transfer ya está a precio de costo, exclusivo para clientes)',
    manager_discount_incl: '🎁 incluye descuento gerencial de',
    manager_discount_applied_pre: '🎁 Descuento gerencial:',
    manager_discount_applied_post: 'ya aplicado',
    on_tours_only: 'sobre los paseos',
    trust_line: 'Tu reserva con una empresa con 10 años en el mercado y 4 premios Travelers Choice',
    checking_dates: 'Verificando fechas...',
    generate_pix: '🟩 Generar PIX ·',
    pay_with_card: '💳 Pagar con tarjeta',
    processing: 'Procesando...',

    dates_intro: 'Antes de confirmar el pago, verifica que todas las fechas de tus paseos tengan cupos disponibles:',
    no_date_selected: 'Sin fecha seleccionada',
    person: 'persona',
    people: 'personas',
    avail_ok: '✓ Disponible',
    choose_a_date: 'Elige una fecha',
    no_spots: 'Sin cupos',
    available_count: 'disponibles',
    unavailable: 'No disponible',
    dates_warning: '⚠️ Algunos paseos necesitan ajuste de fecha. Usa el calendario en cada paseo (arriba) para seleccionar una fecha disponible y vuelve aquí.',
    back: '← Volver',
    confirm_and_pay: 'Confirmar y pagar →',
    close_adjust_dates: '← Cerrar y ajustar fechas',

    generating_qr: 'Generando código QR PIX...',
    or_copy_code: 'O copia el código PIX:',
    copy_code: '📋 Copiar código',
    code_copied: '¡Código copiado!',
    paying_now: '📲 Pagando ahora',
    remaining_hour: '⏳ Saldo',
    balance_note: 'El saldo restante debe pagarse hasta 48h antes del primer servicio.',
    waiting_confirmation: 'Esperando la confirmación del pago...',
    auto_check_5s: 'Verificando automáticamente cada 5 segundos',

    installments_title: 'Cuotas',
    cash: 'al contado',
    total_word: 'total',
    card_data: 'Datos de la tarjeta',
    name_on_card: 'Nombre en la tarjeta',
    card_number: 'Número de la tarjeta',
    billing_address: '📍 Dirección de facturación',
    required: '(obligatorio)',
    cep_placeholder: 'Código postal',
    number_placeholder: 'Número',

    payment_confirmed: '¡Pago confirmado!',
    success_text: 'Tu reserva fue creada con éxito. Pronto recibirás la confirmación y el voucher con todos los detalles.',
    see_my_reservation: 'Ver mi reserva',

    immediate_confirmation: '· confirmación inmediata',
    credit_card_title: 'Tarjeta de crédito',
    budget_summary: 'Resumen del presupuesto',
    pix_down: '✅ PIX anticipo',
    pix_paid: '✅ PIX — pagado',
    card_paid_prefix: '✅ Tarjeta',
    pay_balance_48h: 'Paga el saldo hasta 48h antes de embarcar',
    total_to_pay: 'Total a pagar',
    valid_until_pre: '⏱️ Valores válidos hasta',
    valid_until_post: '· ¡Reserva ahora y asegura estos valores!',

    your_answer: 'Tu respuesta',
    refuse: 'Rechazar',
    refuse_intro: 'Cuéntanos el motivo (opcional). ¡Tu opinión nos ayuda a mejorar!',
    refuse_placeholder: 'Ej: precio fuera del presupuesto, fechas no disponibles...',
    confirm_refuse: 'Confirmar rechazo',
    back_simple: 'Volver',
    approve_error: 'Error al aprobar. Intenta nuevamente.',
    refuse_error: 'Error al rechazar. Intenta nuevamente.',
    approved_title: '¡Presupuesto aprobado!',
    approved_text: 'Nuestro equipo te contactará pronto para finalizar tu reserva.',

    footer_about: 'Somos especialistas en turismo de experiencia en Santiago, Buenos Aires y destinos de Sudamérica. Cada viaje se planifica con cuidado y atención para que vivas momentos inolvidables.',
    download_app: 'Descarga la FT App',
    available_on_ios: 'Disponible en',
    available_on_android: 'Disponible en',
    footer_personal: 'Este presupuesto es personal e intransferible · Ref.',
    terms_title: 'Términos y condiciones del presupuesto',

    intl_payment_note: 'Los precios están en reales brasileños (BRL). También puedes pagar en USD con el selector de moneda abajo.',

    // ── Pago internacional (Nautt/Aloha) ──────────────────────────────────────
    pay_currency_label: 'Pagar en tu moneda',
    pay_currency_brl: 'BRL',
    step_ext_pay: '💳 Pago Internacional',
    ext_pay_opening: 'Preparando tu link de pago...',
    ext_pay_opened: 'Tu página de pago está abierta en una nueva pestaña. Completa el pago allí — esta página se actualiza automáticamente.',
    ext_pay_reopen: '🔗 Reabrir página de pago',
    ext_pay_waiting: 'Verificando confirmación de pago...',
    ext_pay_error: 'No se pudo generar el link de pago. Inténtalo de nuevo o contacta a tu consultor.',
    rate_error: 'Cotización no disponible — intentar de nuevo',
    coming_soon_short: 'pronto',
    confirm_and_pay_usd: 'Continuar al pago en',
  },
};

export const makeT = (lang) => {
  const d = presaleDict[lang] || presaleDict.pt;
  return (key) => d[key] ?? presaleDict.pt[key] ?? key;
};
